import { render, staticRenderFns } from "./AkbsPendingList.vue?vue&type=template&id=5400c1cc&scoped=true&"
import script from "./AkbsPendingList.vue?vue&type=script&lang=js&"
export * from "./AkbsPendingList.vue?vue&type=script&lang=js&"
import style0 from "./AkbsPendingList.vue?vue&type=style&index=0&id=5400c1cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5400c1cc",
  null
  
)

export default component.exports